import React from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "./CookieConsent.scss";

const CONSENT_KEY = "rv_cookie_consent";

class CookieConsent extends React.Component {
  state = {
    visible: false,
  };

  componentDidMount() {
    if (!window.localStorage.getItem(CONSENT_KEY)) {
      this.setState({ visible: true });
    }
  }

  updateConsent(granted) {
    if (typeof window.gtag !== "function") {
      return;
    }

    window.gtag("consent", "update", {
      ad_storage: granted ? "granted" : "denied",
      ad_user_data: granted ? "granted" : "denied",
      ad_personalization: granted ? "granted" : "denied",
      analytics_storage: granted ? "granted" : "denied",
    });
  }

  accept = () => {
    window.localStorage.setItem(CONSENT_KEY, "granted");
    this.updateConsent(true);
    this.setState({ visible: false });
  };

  decline = () => {
    // Consent Mode already defaults to "denied", so declining just records
    // the choice and keeps that default in place.
    window.localStorage.setItem(CONSENT_KEY, "denied");
    this.setState({ visible: false });
  };

  render() {
    if (!this.state.visible) {
      return null;
    }

    return (
      <div className="cookie-consent-banner">
        <div className="cookie-consent-popup">
          <p className="cookie-consent-text mb-0">
            We use cookies to help improve your experience. By accepting,
            you agree to our use of cookies.
          </p>
          <Button
            className="btn-round cookie-consent-ok"
            color="dark"
            size="sm"
            aria-label="Accept cookies"
            onClick={this.accept}
          >
            <FontAwesomeIcon icon={faCheck} />
          </Button>
        </div>
      </div>
    );
  }
}

export default CookieConsent;
